var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"pss__footer"},[_c('copyright'),_c('statement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }